/*
This file is located in the main branch
Last time the file was updated (UTC): [11/6/2024 4:40:59AM]
Permissions to update outside the main branch: [false]
*/

import { requiredRule, ValidatedDropDownList, ValidatedInput } from '@finbeat/react-toolkit';
import { BOValidatedDatePicker } from 'base-components/BOValidatedDatePicker/BOValidatedDatePicker';
import { datetimeFormat } from 'constans/dateFormat';
import { differenceInDays, parseISO } from 'date-fns';
import { LeadgenFilter as LeadgenFilterDto } from 'models/api/leadgen';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import { LeadgenProps } from './Leadgen';

export const LeadgenStatsFilter = (props: LeadgenProps) => <LeadgenFilter {...props} />;

export const LeadgenDailyStatsFilter = (props: LeadgenProps) => <LeadgenFilter {...props} />;

export const LeadgenHourlyStatsFilter = (props: LeadgenProps) => <LeadgenFilter {...props} />;

export const LeadgenFilter = ({ leagensList, leadgenListLoading }: LeadgenProps) => {
    const { t } = useTranslation();

    const { watch } = useFormContext<LeadgenFilterDto>();
    const sd = watch('sd');
    const ed = watch('ed');

    const validator = (value?: string) => {
        const startDate = sd ? parseISO(sd) : new Date();
        const endDate = ed ? parseISO(ed) : new Date();

        if (startDate > endDate) {
            return t('BackOfficeFilterPeriodStartDateAfterStartDate');
        }

        const diffDays = differenceInDays(endDate, startDate);

        if (diffDays > 30) {
            return t('BackOfficeFilterPeriodOverLimit', { days: 30 });
        }
    };

    return (
        <>
            <Row>
                <Col md={6}>
                    <BOValidatedDatePicker
                        name={`sd`}
                        inputProps={{
                            label: t('BackOfficeDtFrom'),
                        }}
                        dateFormat={datetimeFormat}
                        rules={{
                            required: requiredRule,
                            validate: validator,
                        }}
                    />
                </Col>

                <Col md={6}>
                    <BOValidatedDatePicker
                        name={`ed`}
                        inputProps={{
                            label: t('BackOfficeTo'),
                        }}
                        dateFormat={datetimeFormat}
                        rules={{
                            required: requiredRule,
                            validate: validator,
                        }}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <ValidatedDropDownList<LeadgenFilterDto, true>
                        name="ids"
                        isLoading={leadgenListLoading}
                        label={t('BackOfficeName')}
                        items={[...leagensList]}
                        isMulti
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <ValidatedInput
                        id="ds-show-inactive-id"
                        name="showInactive"
                        type="checkbox"
                        label={t('BackOfficeShowInactive')}
                    />
                </Col>
            </Row>
        </>
    );
};
